import { isAxiosError } from '@seeqdev/api';

export type TrackErrorType = 'validation_error' | 'unauthorized' | 'not_found' | 'conflict' | 'failure';

/** Maps an API error to a telemetry error type, defaulting to 'failure'. */
export function trackErrorType(error: unknown): TrackErrorType {
  const status = isAxiosError(error) ? error.response?.status : undefined;
  if (status === 400 || status === 422) return 'validation_error';
  if (status === 401 || status === 403) return 'unauthorized';
  if (status === 404) return 'not_found';
  if (status === 409) return 'conflict';
  return 'failure';
}
